export const paramValueToString = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '';
  } else if ('object' === typeof value) {
    return JSON.stringify(value);
  } else {
    return String(value);
  }
};

export const encodeParam = (key: string, value: unknown, isMacro = false): string => {
  if (!key) {
    return '';
  } else if (Array.isArray(value)) {
    const arrayKey = encodeURIComponent(key);
    return value
      .map((arrayValue) => {
        const newValue = isMacro ? arrayValue : encodeURIComponent(paramValueToString(arrayValue));
        return `${arrayKey}[]=${newValue}`;
      })
      .join('&');
  } else {
    const newValue = isMacro ? value : encodeURIComponent(paramValueToString(value));
    return `${encodeURIComponent(key)}=${newValue}`;
  }
};

export const objectToParams = (obj: Record<string | number | symbol, unknown>): string => {
  const ret = [];
  for (const param of Object.keys(obj)) {
    ret.push(encodeParam(param, obj[param]));
  }
  return ret.filter(Boolean).join('&');
};

export const addParamsToUrl = (
  url: string,
  params?: Array<{ param: string; value: unknown }>,
  macros?: Set<string>
): string => {
  if (params?.length) {
    const paramString = params
      .map((p) => encodeParam(p.param, p.value, macros?.has(`${p.value}`)))
      .filter(Boolean)
      .join('&');
    if (paramString) {
      return `${url}${url.includes('?') ? '&' : '?'}${paramString}`;
    }
  }
  return url;
};

export const printUrl = (url: string, params?: { key: string; value: string }[]) => {
  const macros = new Set(params?.map((p) => `{${p.key}}`));
  const transformedParams =
    params?.map((pc) => ({
      param: pc.value,
      value: `{${pc.key}}`,
    })) ?? [];
  return addParamsToUrl(url, transformedParams, macros);
};
